/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_Ingested_Data_LabelInputs */

const es_tyc_definitions_ingested_data_label = /** @type {(inputs: Tyc_Definitions_Ingested_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos Ingestados`)
};

const en_tyc_definitions_ingested_data_label = /** @type {(inputs: Tyc_Definitions_Ingested_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingested Data`)
};

/**
* | output |
* | --- |
* | "Ingested Data" |
*
* @param {Tyc_Definitions_Ingested_Data_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_ingested_data_label = /** @type {((inputs?: Tyc_Definitions_Ingested_Data_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_Ingested_Data_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_ingested_data_label(inputs)
	return en_tyc_definitions_ingested_data_label(inputs)
});
export { tyc_definitions_ingested_data_label as "tyc.definitions.ingested_data_label" }